import { cn } from "@/lib/utils"

/** A single KPI metric tile (icon + title + bold value + optional subtitle).
 *  Shared by the Users tab's metrics row. The `variant` tints the border to
 *  signal health. */
export function KpiCard({
  title,
  value,
  icon: Icon,
  subtitle,
  variant = "default",
}: {
  title: string
  value: string | number
  icon: React.ComponentType<{ className?: string }>
  subtitle?: string
  variant?: "default" | "success" | "warning" | "danger"
}) {
  const variantStyles = {
    default: "bg-card",
    success: "bg-card border-green-200",
    warning: "bg-card border-amber-200",
    danger: "bg-card border-red-200",
  }

  return (
    <div className={cn("rounded-lg border p-4", variantStyles[variant])}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-muted-foreground">{title}</span>
        <Icon className="size-4 text-muted-foreground" />
      </div>
      <div className="text-2xl font-bold">{value}</div>
      {subtitle && (
        <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
      )}
    </div>
  )
}
